const en = {
    HOME: 'Mark0UI is begin, yoooooooo',
    DescribePositiveQuestion: 'Good you are feeling {{emotion}} today, anything behind it?',
    DescribeNegativeQuestion: 'Is there anything specific you can identify that has made you feel {{emotion}}?'
};

export default en;
